import React, { useState, useEffect } from "react";
import Header from "../../Hoc/Header";
import Card from "../../../Assets/img/credit-card.png";
import Footer from "../../Hoc/Footer";
import axios from "axios";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import { useNavigate } from "react-router-dom";

function ConsPayment() {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [user, setUser] = useState([]);
  const [link, setLink] = useState("");
  const [codeStatus, setCodeStatus] = useState(null);
  const [actualCode, setActualCode] = useState("");
  const [discount, setDiscount] = useState("");
  const [codeLoader, setCodeLoader] = useState(false);
  const [giftCode, setGiftCode] = useState("");

  useEffect(() => {
    getUser();
  }, []);

  const getUser = () => {
    axios
      .get(
        `https://arianaapp.arianaapply.com/api/V1/get-user/${localStorage.getItem(
          "token"
        )}`
      )
      .then((response) => {
        console.log("user", response);
        setUser(response.data);
      })
      .catch((err) => console.log(err));
  };

  const getPaymentLink = () => {
    setLoader(true);
    axios
      .post(
        "https://arianaapp.arianaapply.com/api/V1/payment-for-Non-free-consultation-pwa",
        {
          user_id: user._id,
          email: user.email,
          mobile: user.phone,
          code: actualCode,
        }
      )
      .then((res) => {
        console.log(res);
        setLoader(false);
        setLink(res.data);
        setTimeout(() => {
          window.open(`${res.data}`);
        }, 300);
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });
  };

  const submitGiftCode = () => {
    setCodeLoader(true);
    axios
      .post("https://arianaapp.arianaapply.com/api/V1/check-discount-code", {
        code: giftCode,
      })
      .then((res) => {
        if (res.data.status === 404) {
          setCodeStatus(false);
          setCodeLoader(false);
        } else {
          setCodeStatus(true);
          setDiscount(res.data.data.discount);
          setActualCode(giftCode);
          setCodeLoader(false);
        }
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
        setCodeLoader(false);
      });
  };

  return (
    <div className="pay">
      <Header title={"پرداخت"} />

      <div className="pay-box">
        <img src={Card} alt="card" />
        <span>پرداخت</span>
        <p>جهت ثبت درخواست مشاوره تخصصي مبلغ 200 هزار تومان پرداخت نماييد.</p>

        <div className="pay-gift-code">
          <label>کد تخفیف:</label>
          <div className="gift-code-wrapper">
            <div className="gift-code-input-wrapper">
              <input
                type="text"
                value={giftCode}
                name="giftCode"
                onChange={(e) => setGiftCode(e.target.value)}
                placeholder="کد تخفیف خود را وارد کنید..."
              />
              <span
                className={
                  codeStatus === true ? "success-code" : "danger-code"
                }
              >
                {codeStatus === true
                  ? `کد تخفیف ${discount} درصدی شما با موفقیت ثبت شد `
                  : codeStatus === false
                  ? "کد تخفیف وارد شده صحیح نمیباشد"
                  : null}
              </span>
            </div>
            <button onClick={submitGiftCode}>
              {codeLoader === true ? (
                <Loader
                  type="TailSpin"
                  color="#251d23"
                  height={20}
                  width={20}
                />
              ) : (
                "ثبت کد"
              )}
            </button>
          </div>
        </div>

        <button className="pay-btn" onClick={getPaymentLink}>
          {loader === false ? (
            <span>پرداخت</span>
          ) : (
            <Loader type="TailSpin" color="white" height={30} width={30} />
          )}
        </button>
      </div>

      <Footer />
    </div>
  );
}

export default ConsPayment;